import { render, staticRenderFns } from "./wifiList.vue?vue&type=template&id=24f8252f&scoped=true&"
import script from "./wifiList.vue?vue&type=script&lang=js&"
export * from "./wifiList.vue?vue&type=script&lang=js&"
import style0 from "./wifiList.vue?vue&type=style&index=0&id=24f8252f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8252f",
  null
  
)

export default component.exports